import { useEffect, useState } from 'react'
import styles from '../responsive.mixin.scss'

export enum Breakpoint {
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl'
}

const BREAKPOINTS = {
  [Breakpoint.XL]: styles.xl,
  [Breakpoint.LG]: styles.lg,
  [Breakpoint.MD]: styles.md,
  [Breakpoint.SM]: styles.sm,
  [Breakpoint.XS]: styles.xs
}

export function useLessThanBreakpoint(breakpoint: Breakpoint): boolean {
  const less = (breakpoint: Breakpoint) =>
    `only screen and (max-width: calc(${BREAKPOINTS[breakpoint]} - 1px))`
  const getMatches = (query: string): boolean => {
    // Prevents SSR issues
    if (typeof window !== 'undefined') {
      return window.matchMedia(query).matches
    }
    return false
  }

  const [matches, setMatches] = useState<boolean>(getMatches(less(breakpoint)))

  function handleChange() {
    setMatches(getMatches(less(breakpoint)))
  }

  useEffect(() => {
    // https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia
    // matchMedia is an api that takes an media query and returns a boolean if the media query is true/false
    const matchMedia = window.matchMedia(less(breakpoint))
    // Triggered at the first client-side load and if query changes
    handleChange()
    matchMedia.addEventListener('change', handleChange)
    return () => matchMedia.removeEventListener('change', handleChange)
  }, [breakpoint])

  return matches
}
